namespace TabAurous.ECommerce {
    export interface ECommSalesReturnRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        POSCustomerId?: number;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        RoundOff?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ECommSalesReturnItemsRow[];
        TaxDetails?: ECommSalesReturnTaxRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        IsReturned?: boolean;
        ProductItemImage?: string;
        PosCustomerCode?: string;
        CustomerName?: string;
        BirthDate?: string;
        Anniversary?: string;
        TaxId?: string;
        PanNumber?: string;
        Address?: string;
        Mobile?: string;
    }

    export namespace ECommSalesReturnRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ECommerce.ECommSalesReturn';
        export const deletePermission = 'EComm:ECommSalesReturn:Delete';
        export const insertPermission = 'EComm:ECommSalesReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommSalesReturn:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            RoundOff = "RoundOff",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            TaxDetails = "TaxDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            IsReturned = "IsReturned",
            ProductItemImage = "ProductItemImage",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            BirthDate = "BirthDate",
            Anniversary = "Anniversary",
            TaxId = "TaxId",
            PanNumber = "PanNumber",
            Address = "Address",
            Mobile = "Mobile"
        }
    }
}
